// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/img/contact-header.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/img/signup-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Barlow-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/img/bg-light.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

html {
  scroll-behavior: smooth;
}
 :root{
  --bs-nav-link-font-size:16px!important;
  
} 

  /* .text-primary {
    --bs-text-opacity: 1;
    color: rgba(var(--bs-primary-rgb),var(--bs-text-opacity)) !important;
  } */
  

/* fallback */

.bg-home {background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-repeat: no-repeat;background-attachment: absolute;background-position: right;background-position-y: center;background-position-y: top;background-size: 48vw;height: auto;text-align: left;padding: 3rem;}
.bg-register {background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___})!important;}

@font-face {
  font-family: 'Barlow Regular';
  font-style: normal;
  font-weight: normal;
  src: local('Barlow Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}
@font-face {
    font-family: 'Barlow Medium';
    font-style: normal;
    font-weight: normal;
    src: local('Barlow Medium'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  }
  @font-face {
    font-family: 'Barlow Bold';
    font-style: normal;
    font-weight: normal;
    src: local('Barlow Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
  }  
  body {
    font-family: var(--bs-body-font-family);
    font-size: var(--bs-body-font-size);
    font-weight: var(--bs-body-font-weight);
    line-height: var(--bs-body-line-height);
    letter-spacing: 0.025rem;
    color: var(--bs-body-color);
    text-align: var(--bs-body-text-align);
    -webkit-text-size-adjust: 100%;
  }
  
/* body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Barlow Regular',sans-serif!important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
} */



/* :root {
  --primary-blue: rgb(0, 0, 255);
  --secondary-blue: rgb(96, 96, 182);

  --text-primary-light: black;
  --text-primary-dark: white;

  --text-secondary-light: rgb(70, 70, 70);
  --text-secondary-dark: rgb(160, 160, 160);

  --bg-primary-light: white;
  --bg-primary-dark: black;

  --bg-secondary-light: rgb(212, 212, 212);
  --bg-secondary-dark: rgb(34, 34, 34);

  --bg-navbar-light: rgb(104, 104, 255);
  --bg-navbar-dark: rgb(29, 29, 58);
}


.light-theme {
  --bs-primary:#e30613;
  --text-primary: var(--text-primary-light);
  --text-secondary: var(--text-secondary-light);
  --bg-primary: var(--bg-primary-light);
  --bg-secondary: var(--bg-secondary-light);
  --bg-navbar: var(--bg-navbar-light);
  --bs-btn-bg: #e30613!important;
  --bs-light-rgb: var(--bs-gray-500);
  
}

.dark-theme {
  --bs-primary:#e0e0e0;
  --bs-btn-bg: #e0e0e0!important;
  --text-primary: var(--text-primary-dark);
  --text-secondary: var(--text-secondary-dark);
  --bg-primary: var(--bg-primary-dark);
  --bg-secondary: var(--bg-secondary-dark);
  --bg-navbar: var(--bg-navbar-dark);
  --bs-light-rgb: 0,0,0;
}

.btn-primary{
  background-color: var(--bs-primary)!important;
} */

.sticky-top{
  top:55!important
}

.content-container {
  min-height: calc(83vh);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  max-width: 100%!important;
}

.footer--pin {
  position: relative;
  left: 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";;AAEA;EACE,uBAAuB;AACzB;CACC;EACC,sCAAsC;;AAExC;;EAEE;;;KAGG;;;AAGL,aAAa;;AAEb,UAAU,yDAAwD,CAAC,4BAA4B,CAAC,+BAA+B,CAAC,0BAA0B,CAAC,6BAA6B,CAAC,0BAA0B,CAAC,qBAAqB,CAAC,YAAY,CAAC,gBAAgB,CAAC,aAAa,CAAC;AACtR,cAAc,mEAA6D,CAAC;;AAE5E;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,oFAAsF;AACxF;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,mFAAoF;EACtF;EACA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,iFAAgF;EAClF;EACA;IACE,uCAAuC;IACvC,mCAAmC;IACnC,uCAAuC;IACvC,uCAAuC;IACvC,wBAAwB;IACxB,2BAA2B;IAC3B,qCAAqC;IACrC,8BAA8B;EAChC;;AAEF;;;;;GAKG;;;;AAIH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8CG;;AAEH;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,yDAAgD;EAChD,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX","sourcesContent":["\n\nhtml {\n  scroll-behavior: smooth;\n}\n :root{\n  --bs-nav-link-font-size:16px!important;\n  \n} \n\n  /* .text-primary {\n    --bs-text-opacity: 1;\n    color: rgba(var(--bs-primary-rgb),var(--bs-text-opacity)) !important;\n  } */\n  \n\n/* fallback */\n\n.bg-home {background-image: url('./assets/img/contact-header.png');background-repeat: no-repeat;background-attachment: absolute;background-position: right;background-position-y: center;background-position-y: top;background-size: 48vw;height: auto;text-align: left;padding: 3rem;}\n.bg-register {background-image: url('./assets/img/signup-bg.jpg')!important;}\n\n@font-face {\n  font-family: 'Barlow Regular';\n  font-style: normal;\n  font-weight: normal;\n  src: local('Barlow Regular'), url('./assets/fonts/Barlow-Regular.woff') format('woff');\n}\n@font-face {\n    font-family: 'Barlow Medium';\n    font-style: normal;\n    font-weight: normal;\n    src: local('Barlow Medium'), url('./assets/fonts/Barlow-Medium.woff') format('woff');\n  }\n  @font-face {\n    font-family: 'Barlow Bold';\n    font-style: normal;\n    font-weight: normal;\n    src: local('Barlow Bold'), url('./assets/fonts/Barlow-Bold.woff') format('woff');\n  }  \n  body {\n    font-family: var(--bs-body-font-family);\n    font-size: var(--bs-body-font-size);\n    font-weight: var(--bs-body-font-weight);\n    line-height: var(--bs-body-line-height);\n    letter-spacing: 0.025rem;\n    color: var(--bs-body-color);\n    text-align: var(--bs-body-text-align);\n    -webkit-text-size-adjust: 100%;\n  }\n  \n/* body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Barlow Regular',sans-serif!important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n} */\n\n\n\n/* :root {\n  --primary-blue: rgb(0, 0, 255);\n  --secondary-blue: rgb(96, 96, 182);\n\n  --text-primary-light: black;\n  --text-primary-dark: white;\n\n  --text-secondary-light: rgb(70, 70, 70);\n  --text-secondary-dark: rgb(160, 160, 160);\n\n  --bg-primary-light: white;\n  --bg-primary-dark: black;\n\n  --bg-secondary-light: rgb(212, 212, 212);\n  --bg-secondary-dark: rgb(34, 34, 34);\n\n  --bg-navbar-light: rgb(104, 104, 255);\n  --bg-navbar-dark: rgb(29, 29, 58);\n}\n\n\n.light-theme {\n  --bs-primary:#e30613;\n  --text-primary: var(--text-primary-light);\n  --text-secondary: var(--text-secondary-light);\n  --bg-primary: var(--bg-primary-light);\n  --bg-secondary: var(--bg-secondary-light);\n  --bg-navbar: var(--bg-navbar-light);\n  --bs-btn-bg: #e30613!important;\n  --bs-light-rgb: var(--bs-gray-500);\n  \n}\n\n.dark-theme {\n  --bs-primary:#e0e0e0;\n  --bs-btn-bg: #e0e0e0!important;\n  --text-primary: var(--text-primary-dark);\n  --text-secondary: var(--text-secondary-dark);\n  --bg-primary: var(--bg-primary-dark);\n  --bg-secondary: var(--bg-secondary-dark);\n  --bg-navbar: var(--bg-navbar-dark);\n  --bs-light-rgb: 0,0,0;\n}\n\n.btn-primary{\n  background-color: var(--bs-primary)!important;\n} */\n\n.sticky-top{\n  top:55!important\n}\n\n.content-container {\n  min-height: calc(83vh);\n  background-image: url('assets/img/bg-light.png');\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  max-width: 100%!important;\n}\n\n.footer--pin {\n  position: relative;\n  left: 0;\n  bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
